import type { LanguageDto } from "@/api/types";

const PREVIOUSLY_SUPPORTED_CONTENT_LANGUAGE_IDS = new Set([
  "nl",
  "en",
  "de",
  "pt",
  "es",
  "pl",
  "fr",
  "it",
  "tr",
  "bg",
  "hu",
  "uk",
  "ro",
]);

/** Normalizes a browser language tag and returns its lowercase base segment. */
export function getBaseLanguageCode(languageTag: string): string {
  return languageTag.trim().toLowerCase().split("-")[0];
}

/**
 * Shows the prompt to onboarded users when their browser language is supported,
 * has not been handled before, and differs from their selected content language.
 */
export function shouldShowSupportedLanguagePrompt({
  isOnboarded,
  supportedLanguage,
  selectedLanguageId,
  handledLanguageId,
}: {
  isOnboarded: boolean;
  supportedLanguage: LanguageDto | undefined;
  selectedLanguageId: string | undefined;
  handledLanguageId: string;
}): boolean {
  // Underscore-delimited values are legacy catalogue-history markers; keep this compatibility check during cleanup.
  const hasHandledLanguage =
    handledLanguageId === supportedLanguage?.id || handledLanguageId.split("_").includes(supportedLanguage?.id ?? "");

  return Boolean(
    isOnboarded &&
    supportedLanguage &&
    !PREVIOUSLY_SUPPORTED_CONTENT_LANGUAGE_IDS.has(supportedLanguage.id) &&
    !hasHandledLanguage &&
    selectedLanguageId !== supportedLanguage.id,
  );
}
